// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"80431939","208":"81503a24","592":"02b72713","760":"b200052f"}[chunkId] + ".chunk.js";
};